// e.g. scrollToTarget(document.getElementById('foo'));

function offset(target) {
    let left = 0,
        top = 0;

    while (target && target !== document.body) {
        if (target.offsetLeft) {
            left += target.offsetLeft;
            top += target.offsetTop;
        }
        target = target.offsetParent;
    }
    return { left: left, top: top + 168 };
}
window.scrollToTarget = (target) => {
    const pos = offset(target);
    window.scrollTo(pos.left, pos.top);
    return pos;
}


// WEBPACK FOOTER //
// ./src/assets/js/scrollTo.js